module.exports = __webpack_public_path__ + "img/mobile-services.b973bc3f.svg";